import manifest from '../../../../version.json';

export const version = {
  ...manifest,
  v: `${manifest.major}.${manifest.minor}.${manifest.patch}`,
  semver: `${manifest.major}.${manifest.minor}.${manifest.patch}+${manifest.git}`,
};

window.version = version;
